import { auctionsStatuses } from 'constants/auctions';

export const getAuctionStatuses = (onlyMyBids, onlyMyListings, onlyInPreview, isClose) => {
  const formatedStatuses = Object.values(auctionsStatuses);

  if (onlyMyBids) return formatedStatuses.filter(item => !!item.onlyMyBids).map(item => item.name);
  if (onlyMyListings)
    return formatedStatuses.filter(item => !!item.onlyMyListings).map(item => item.name);
  if (onlyInPreview)
    return formatedStatuses.filter(item => !!item.onlyInPreview).map(item => item.name);
  return isClose
    ? formatedStatuses.filter(item => !!item.closeAuction).map(item => item.name)
    : formatedStatuses.filter(item => !!item.activeAuction).map(item => item.name);
};

export const getAuctionTypes = () => {
  if (CONFIG.AUCTION_TYPE === 'collection') {
    return ['catalog'];
  }
  // if (onlyMyBids) return [];
  // if (onlyMyListings) return [];
  // if (isCatalog) return ['catalog'];
  return ['JTA', 'FlashSale'];
};
